module.exports = __webpack_public_path__ + "img/gzz.d0dab262.png";